import { devConsole } from '@/lib/devConsole';

export enum LogType {
  Internal = 'internal',
  Error = 'error',
}

export const logTransaction = (type: LogType, message: string, data?: Record<string, unknown>) => {
  const payload = data ? `${message} ${JSON.stringify(data)}` : message;

  if (type === LogType.Error) {
    devConsole.error('[logTransaction]', payload);
    return;
  }

  devConsole.log('[logTransaction]', payload);
};
